import { render } from "./NewForm.vue?vue&type=template&id=32bfc004&scoped=true"
import script from "./NewForm.vue?vue&type=script&lang=js"
export * from "./NewForm.vue?vue&type=script&lang=js"

import "./NewForm.vue?vue&type=style&index=0&id=32bfc004&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bfc004"]])

export default __exports__